/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PeriodDetails model module.
 * @module model/PeriodDetails
 * @version 1.0.0
 */
class PeriodDetails {
    /**
     * Constructs a new <code>PeriodDetails</code>.
     * @alias module:model/PeriodDetails
     */
    constructor() { 
        
        PeriodDetails.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PeriodDetails</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PeriodDetails} obj Optional instance to populate.
     * @return {module:model/PeriodDetails} The populated <code>PeriodDetails</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PeriodDetails();

            if (data.hasOwnProperty('contract_validation')) {
                obj['contract_validation'] = ApiClient.convertToType(data['contract_validation'], 'String');
            }
            if (data.hasOwnProperty('docu_validation')) {
                obj['docu_validation'] = ApiClient.convertToType(data['docu_validation'], 'String');
            }
            if (data.hasOwnProperty('period_ending')) {
                obj['period_ending'] = ApiClient.convertToType(data['period_ending'], 'String');
            }
            if (data.hasOwnProperty('slots')) {
                obj['slots'] = ApiClient.convertToType(data['slots'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {String} contract_validation
 */
PeriodDetails.prototype['contract_validation'] = undefined;

/**
 * @member {String} docu_validation
 */
PeriodDetails.prototype['docu_validation'] = undefined;

/**
 * @member {String} period_ending
 */
PeriodDetails.prototype['period_ending'] = undefined;

/**
 * @member {Number} slots
 */
PeriodDetails.prototype['slots'] = undefined;






export default PeriodDetails;

